import { StudentIdentifierOrganizationTypes } from './student-identifier-organization-types.model';
import { StudentIdentifiers } from './student-identifiers.model';
import { StudentIdentifierTypes } from './student-identifier-types.model';
import { Organization } from 'src/app/component/common-components/organizations/model/organization.model';
export class StudentIdentifierOrganizations {
    'ID': number;
    'STUDENT_IDENTIFIER_ID': number;
    'ORGANIZATIONS_ID': number;
    'STUDENT_ID_ORGANIZATION_TYPES_ID': number;
    'CREATED_BY': string;
    'CREATED_DATE': Date;
    'MODIFIED_BY': string;
    'MODIFIED_DATE': Date;
    'ORGANIZATION': Organization;
    'STUDENT_IDENTIFIER_TYPES': StudentIdentifierTypes;
    'STUDENT_IDENTIFIERS': StudentIdentifiers[];
    'STUDENT_ID_ORGANIZATION_TYPES': StudentIdentifierOrganizationTypes;
}
